
export function asArray (value) {
  if (value === undefined) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  return [value];
}

export function unique (arr) {
  let result = [];
  let arrLen = arr.length;
  for (let i = 0; i < arrLen; i++) {
    if (!utils.inArray(arr[i], result)) {
      result.push(arr[i]);
    }
  }
  return result;
}


export function inArray (needle, haystack) {
  // slightly more naive but slightly faster than indexOf
  let arrLen = haystack.length;
  for (let i = 0; i < arrLen; i++) {
    if ( haystack[i] === needle ) {
      return true;
    }
  }
}

export function removeAllFrom (toRemove, arr) {
  while (i < arr.length) {
    if (toRemove === arr[i]) {
      arr.splice(i, 1);
    } else {
      i++;
    }
  }
  return arr;
}

export function ensureIncluded (arr, shouldBeIncluded, element) {
  let isIncluded = arr.includes(element);
  if (isIncluded && !shouldBeIncluded) {
    return arr.filter(e => e !== element);
  }
  if (!isIncluded && shouldBeIncluded) {
    return arr.concat([element]);
  }
  return arr;
}

/**
 * Map over arrays OR objects
 * @param  {Array|Object|Map|Set}   iterable
 * @param  {Function} fn
 * @return {Array}
 */
export function map (iterable, fn) {
  if (Array.isArray(iterable)) {
    return iterable.map(fn);
  }
  let mapped = [];
  if ((typeof Map !== undefined && iterable instanceof Map)
      || (typeof Set !== undefined && iterable instanceof Set)) {
    for (let key of iterable) {
      mapped.push(fn(iterable[key], key));
    }
  } else {
    // plain object
    for (let key in iterable) {
      mapped.push(fn(iterable[key], key));
    }
  }
  return mapped;
}

export function flatten (arr) {
  return arr.reduce((p, n) => Array.isArray(n) ? p.concat(flatten(n)) : p.concat([n]), []);
}


export function *eachPartition (collection, size) {
  let partition = [];
  for (let item of collection) {
    if (partition.length < size) {
      partition.push(item);
    } else {
      yield partition;
      partition = [];
    }
  }
}


// set stuff!
export function *eachComplement (compareIterable, missingFromIterable) {
  let compareSet = new Set(compareIterable);
  for (let item of missingFromIterable) {
    if (!compareSet.has(item)) {
      yield item;
    }
  }
}

export function *eachIntersection (compareIterable, intersectIterable) {
  for (let compareIntersect of compareIterable) {
    for (let potentialIntersect of intersectIterable) {
      if (compareIntersect === potentialIntersect) {
        yield potentialIntersect;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-utils/collections.js